import type {Schemas} from 'api/dto.generated';
import type {FilterSet} from '../types';
import {sortFilterSets} from '../functions';
import {mapFilters} from './mapFilters';

export const mapSavedFilters = (dto: Schemas.FilterSet[]): FilterSet[] => {
  return dto.map(mapSavedFilter).sort(sortFilterSets);
};

export const mapSavedFilter = (dto: Schemas.FilterSet): FilterSet => {
  return {
    ...dto,
    filters: mapFilters(dto.filters),
  };
};
